import axios from 'axios';
import { MOB_PRODUCTS_PAGE_SIZE } from '../../Slider/SliderMobNew';
import { ensureMediaUrl } from '../../utils/mediaUrl';

/**
 * First page of POST /products — same mapping as SliderMobNew / touch experiment (rich fields).
 */
export async function fetchMobProductsFirstPage(queryParams) {
    const token = localStorage.getItem('token');
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const response = await axios.post(
        '/products',
        { ...queryParams, page: 1, size: MOB_PRODUCTS_PAGE_SIZE },
        config
    );
    const data = response.data || [];
    return data
        .filter((item) => item.urls && item.urls.length > 0)
        .map((item) => ({
            id: item._id,
            urls: item.urls.map((u) => ensureMediaUrl(u)),
            title: item.title,
            price: item.price,
            brand: item.brand,
            mrp: item.mrp,
            rating: item.rating,
            reviewCount: item.reviewCount,
            isNew: item.isNew,
        }));
}
